import React, { useContext, useMemo } from 'react';

import VehicleList from '../components/lists/VehicleList';
import { AuthContext } from '../contexts/authContext';
import {
  useDefaultVehicles,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierVehicleTypesPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const { defaultVehicles } = useDefaultVehicles();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierVehicles = useMemo(
    () => [...defaultVehicles, ...(selectedCarrier?.vehicles || [])],
    [defaultVehicles, selectedCarrier?.vehicles]
  );

  if (!selectedCarrier) {
    return null;
  }

  if (!userHasPermission(selectedCarrier, 'classPermission')) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <VehicleList
        carrier={selectedCarrier}
        id="vehicle-types"
        vehicles={carrierVehicles}
      />
    </Layout>
  );
};

export default CarrierVehicleTypesPage;
